import { CariesStageTypes, FindingType } from "@kells/interfaces/finding";

/**
 * Colors for finding types in Haleon report, matching the xray-image component.
 * Used by haleon-finding-card and passed to koa-xray-image via findingColors prop.
 */
export const HALEON_FINDING_TYPE_COLORS: Record<string, string> = {
  [FindingType.Caries]: "#C1121F",
  [FindingType.Material]: "#6A4C93",
  [FindingType.BoneLoss]: "#5C677D",
  [FindingType.Fracture]: "#F77F00",
  [FindingType.Calculus]: "#D4A017",
  [FindingType.Infection]: "#FF006E",
  [FindingType.DefectiveRestoration]: "#008C8C",
  [FindingType.Plaque]: "#7ED957",
  [FindingType.GumRecession]: "#FF6F61",
  [FindingType.GumInflammation]: "#FF2D55",
  [FindingType.MissingTooth]: "#2979FF",
  [FindingType.Tooth]: "#924c93",
};

/** Caries: single brand color for all stages (no per-stage visualization). */
export const HALEON_CARIES_STAGE_COLORS: Record<CariesStageTypes, string> = {
  [CariesStageTypes.Initial]: "#C1121F",
  [CariesStageTypes.Moderate]: "#C1121F",
  [CariesStageTypes.Advanced]: "#C1121F",
  [CariesStageTypes.Undefined]: "#C1121F",
};

/**
 * Xray-image category keys for the findingColors prop.
 * When passed to koa-xray-image, overrides the default stroke/fill colors.
 */
export const HALEON_XRAY_FINDING_COLORS: Record<string, string> = {
  caries: "#C1121F",
  cariesAdvanced: "#C1121F",
  cariesModerate: "#C1121F",
  cariesInitial: "#C1121F",
  fracture: "#F77F00",
  plaque: "#7ED957",
  gumRecession: "#FF6F61",
  gumInflammation: "#FF2D55",
  missingTooth: "#2979FF",
  boneLoss: "#5C677D",
  boneLossModerate: "#5C677D",
  boneLossAdvanced: "#5C677D",
  tooth: "#6A4C93",
};
